<template>
  <div id="project">
    <div class="project_menu" :style="{
        backgroundColor: '#' + project.color,
      }">
    <span class="menu_title">
      <a href="https://edgeryders.eu" class="logo"> </a>
      <h2>Projects</h2>
    </span>
  </div>

    <div
      class="header"
      :style="{
        backgroundColor: '#' + project.color,
        color: '#' + project.text_color,
      }"
      v-if="project"
    >
      <div class="wrapper">
        <h1><img v-if="getLogo()" class="project_icon" :src="getLogo()" />{{ project.name }}</h1>
        <div v-html="project.description"></div>
        <div v-if="forum">
        <button :style="{color: '#' + project.color}">{{forum.users.length}} Members</button>
        <button :style="{color: '#' + project.color}">Participate</button>
        </div>
      </div>
      <div class="project_logo" :style="{ backgroundImage: 'url(' + logos[id] + ')' }"></div>
    </div>

    <div class="page_main">
      <section class="pages">
        <div class="wrapper">
          <div class="info">
           <h2 :style="{borderBottom: '.5px solid #' + project.color, color: '#' + project.color}">Pages</h2>
             <div class="navigation">
           <div class="nav_button back" :style="{border: '1px solid #' + project.color}">
            </div>

            <div class="nav_button next" :style="{border: '1px solid #' + project.color}">
            </div>
          </div>
           <p>Last updated 12/2/2021 @ 13:41</p>
           
          </div>
         <div class="content">
          <div class="page" v-for="(item, index) in getPages()" :key="index" :style="'background-image: url(' + getThumbnail(item) + ')'">
            <div class="page_info">
              <h3>{{item.title}}</h3>
              <p>{{getSummary(item.excerpt)}}..</p>
              <button @click="openPage(item.id)">Open Page</button>
              <p class="created">{{item.created_at | dateShort}}</p>
            </div>
         </div>
          <div class="page" :style="{ backgroundImage: 'url(' + require('@/assets/reef-intro.png') + ')' }">
            <div class="page_info">
              <h3>Introduction</h3>
              <p>The Reef is a new kind of living space. Made for a happier, healthier, greener and more social lifestyle.</p>
              <button @click="openPage(15298)">Open Page</button>
              <p class="created">2/2/2021</p>
            </div>
         </div>
         </div>
        </div>
      </section>

      <section v-if="news">
        <div class="wrapper">
         <div class="info">
           <h2 :style="{borderBottom: '.5px solid #' + project.color, color: '#' + project.color}">News</h2>
              <div class="navigation">
           <div class="nav_button back" :style="{border: '1px solid #' + project.color}">
            </div>

            <div class="nav_button next" :style="{border: '1px solid #' + project.color}">
            </div>
          </div>
            <p>Last updated {{news[1].created_at | dateShort}} @ {{news[1].created_at | time}}</p>

           
        </div>
        <div class="news">
          <div class="news_item">
            <h4 class="date" :style="{color: '#' + project.color}">{{news[1].created_at | dateLong}}</h4>
            <a href="https://live.edgeryders.eu/paper/10897" class="title">{{news[1].title}}</a>
            <div v-html="news[1].excerpt"></div>
            <a class="read" :style="{backgroundColor: '#' + project.color}" :href="'https://live.edgeryders.eu/paper/' + news[1].id">Read More</a>
          </div>
        </div>
        </div>
      </section>

      <section>
        <div class="wrapper">
         <div class="info">
           <h2 :style="{borderBottom: '.5px solid #' + project.color, color: '#' + project.color}">Events</h2>

                    <div class="navigation">
           <div class="nav_button back" :style="{border: '1px solid #' + project.color}" @click="$refs.vuecal.previous()">
            </div>

            <div class="nav_button next" :style="{border: '1px solid #' + project.color}" @click="$refs.vuecal.next()">
            </div>
          </div>
                                     <div class="info_date">
                                      <span :style="{color: '#' + project.color}" @click="$refs.vuecal.switchView('month')">March 2021</span> <span>Week 2</span></div>

         

          </div>
           <div class="events">

          <VueCal :on-event-click="onEventClick" ref="vuecal" :events="calendar.events" small :timeFrom="540" :timeTo="1240" :selectedDate="calendar.current" :hide-weekdays="[7]" hideTitleBar="true" hideViewSelector="true" :active-view="calendar.view" :disable-views="['years', 'year', 'day']" style="height: 300px; width: 100%" />
        </div>
        </div>
       
      </section>

      <section>
        <div class="wrapper">
         <div class="info">
           <h2 :style="{borderBottom: '.5px solid #' + project.color, color: '#' + project.color}">Contributors</h2>
         </div>
        <div class="contributors">
          <a class="contributor_item" :style="'background: url(' + getProfile(item, 'avatar') + ')'" v-for="(item, index) in contributors" :key="index" :content="`<div class='tooltip_custom' :style='{backgroundColor: getColor()}'><h2>${getProfile(item, 'name')}</h2></div>`" v-tippy="{followCursor : true, offset: '0, 20', touch: false, theme: 'light', placement : 'bottom', arrow : false, arrowType : 'round', animation : 'shift-away' }" :href="getProfile(item, 'url')" target="_blank">
           
          </a>
        </div>
        </div>
      </section>
<!-- 
      <section>
        <div class="wrapper">
         <div class="info">
           <h2 :style="{borderBottom: '.5px solid #' + project.color, color: '#' + project.color}">Edgeryders</h2>
          </div>
        </div>
      </section> -->
    </div>
    <Footer />
  </div>
</template>

<script>
import { bus } from "@/main";
var YAML = require("yamljs");
import moment from "moment";
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import Footer from "./elements/footer.vue";

export default {
  name: "Project",
  data() {
    return {
      project: null,
      category: null,
      forum: null,
      description: null,
      calendar: {
        current: "2021-03-11",
        view: 'week',
        events: [
          {
            start: '2021-03-09 14:00',
            end: '2021-03-09 17:00',
            title: 'title',
            class: 'leisure'
          },
          {
            start: '2021-03-11 10:00',
            end: '2021-03-11 15:00',
            title: 'title'
          }
        ]
      },
      cat_id: null,
      news: null,
      contributors: null,
      id: null,
      menu: {
        'text': 'Projects'
      },
      logos: {
        'the-reef': 'https://thereef.brussels/assets/images/earthos-logo.png',
        'sci-fi-economics': 'https://edgeryders.eu/uploads/default/original/2X/6/682c28093030b12dd48125c7622a2fbec9660f7c.png'
      }
    };
  },
  components: { VueCal, Footer },
  props: [],
  methods: {
    openPage(id){
      bus.$emit("loadPage", {'id': id, 'project': this.id});
    },
    getThumbnail(item){
      if (item.thumbnails) {
        return item.thumbnails[0].url
      } else {
        return false
      }
    },
    getLogo() {
      if (this.project.uploaded_background !== null) {
        return 'https://edgeryders.eu/' + this.project.uploaded_background.url
      }
      else if (this.project.uploaded_logo) {
        return 'https://edgeryders.eu/' + this.project.uploaded_logo.url
      } else {
        return null
      }
    },
    loadProject() {
      var match = this.project.description.match(/<pre>.*?<\/pre>/ims);
      this.getData(this.project.id, 'category');
      console.log(this.category);
      if (match) {
        var xml = new DOMParser().parseFromString(match[0], "text/xml");
        this.config = YAML.parse(xml.getElementsByTagName("code")[0].innerHTML);
        this.getData(this.config.category_id, 'forum');
        if (this.config.news){
          this.news = this.getNews(this.config.news);
        } 
        this.description = this.project.description.replace(match, '');
      } else {
        this.getData(this.project.id, 'forum');
        this.news = this.category.topic_list.topics.sort((a, b) => b.created_at.localeCompare(a.created_at));
        this.description = this.project.description;
      }
    },
    getCategory(id, object) {
      var self = this;
      fetch("https://edgeryders.eu/c/" + id + ".json")
      .then((response) => response.json())
      .then((data) => {
        self[object] = data;
      });
    },
    getData(id, object) {
      var self = this;
      fetch("https://edgeryders.eu/c/" + id + ".json")
      .then((response) => response.json())
      .then((data) => {
        self[object] = data;
        self.news = data.topic_list.topics;
        self.contributors = data.users;
        self.getEvents();
      });
    },
    getProfile(item, value) {
      if (value == 'name') {
        return item.name || '@' + item.username
      }
      if (value == 'avatar') {
        return "https://edgeryders.eu" + item.avatar_template.replace('{size}', 200)
      }
      if (value == 'url') {
        return "https://edgeryders.eu/u/" + item.username
      }
    },
    getColor(){
      return '#' + this.project.color
    },
    getPages() {
     return this.category.topic_list.topics.filter(x => x.tags.includes('page'));
    },
    getEvents() {
     var events = this.category.topic_list.topics.filter(x => x.tags.includes('event'));
     this.calendar.events = events.map(x => this.getEvent(x));
    },
    getEvent(item) {
      var regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])T(2[0-3]|[01][0-9]):[0-5][0-9]/g;
      var match = item.excerpt.match(regex);
      var type; 
      var title = item.title;
      if (item.title.toLowerCase().includes("seminar")) {
        type = "seminar";
        title = item.title.toLowerCase().replace(type, '').replace('-', '');
      }
      if (item.title.toLowerCase().includes("call")) {
        type = "call";
        title = item.title.toLowerCase().replace(type, '').replace('-', '');
      }
      var obj = {
        title: title,
        class: type,
        url: 'https://edgeryders.eu/t/' + item.id,
        start: match[0].replace('T', ' '),
        end: match[1].replace('T', ' ')
      };
      return obj;
    },
    onEventClick(event, e){
      var win = window.open(event.url, '_blank');
  win.focus();
      e.stopPropagation();
    },
    getSummary(text) {
      var element = document.createElement("div");
      element.innerHTML = window.md.render(text);
      return element.innerText.substring(0, 140);
    },
    getNews(tag){
      var self = this;
        fetch("https://edgeryders.eu/tag/" + tag + ".json")
        .then((response) => response.json())
        .then((data) => {
          self.news = data.topic_list.topics.sort((a, b) => b.created_at.localeCompare(a.created_at));
        });
    },
  },
  mounted() {
    var self = this;
    this.id = window.location.pathname.split("/")[2];
    fetch("https://edgeryders.eu/site.json")
      .then((response) => response.json())
      .then((data) => {
        var project = data.categories.filter((x) => x.slug == self.id)[0];
        self.project = project;
        self.loadProject();
      });
  },
  filters: {
    dateLong: function(value) {
      return moment(String(value)).format("dddd, MMMM Do");
    },
    dateShort: function(value) {
      return moment(String(value)).format("DD/MM/YY");
    },
    time: function(value) {
      return moment(String(value)).format("hh:mm A");
    },
  },
  created() {},
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');

.nav_button {
width: 35px;
    height: 35px;

    background-size: 12px !important; 
    @apply block rounded-full border;
  &:hover {
  cursor: pointer;
  background-color: #0088cc !important;
}

  &.back {
@apply mr-2;
 
    background: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M47.4 0a5.6 5.6 0 014 9.5l-37.9 38 37.9 37.9a5.6 5.6 0 010 7.9 5.6 5.6 0 01-7.9 0L1.6 51.5a5.5 5.5 0 01-1.6-4 6 6 0 011.6-4L43.5 1.6A5.4 5.4 0 0147.4 0z'  fill='%230088cc' fill-rule='nonzero'/%3E%3C/svg%3E%0A") no-repeat 60% 52%;
 
     &:hover {
     background: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M47.4 0a5.6 5.6 0 014 9.5l-37.9 38 37.9 37.9a5.6 5.6 0 010 7.9 5.6 5.6 0 01-7.9 0L1.6 51.5a5.5 5.5 0 01-1.6-4 6 6 0 011.6-4L43.5 1.6A5.4 5.4 0 0147.4 0z'  fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E%0A") no-repeat 60% 52%;
   }
  }
  &.next {
         background: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath  d='M47.4 0a5.6 5.6 0 014 9.5l-37.9 38 37.9 37.9a5.6 5.6 0 010 7.9 5.6 5.6 0 01-7.9 0L1.6 51.5a5.5 5.5 0 01-1.6-4 6 6 0 011.6-4L43.5 1.6A5.4 5.4 0 0147.4 0z' fill='%230088cc' fill-rule='nonzero'/%3E%3C/svg%3E%0A") no-repeat 65% center;
transform:scale(-1);
background-position: 60% center;
&:hover {
   background: url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath  d='M47.4 0a5.6 5.6 0 014 9.5l-37.9 38 37.9 37.9a5.6 5.6 0 010 7.9 5.6 5.6 0 01-7.9 0L1.6 51.5a5.5 5.5 0 01-1.6-4 6 6 0 011.6-4L43.5 1.6A5.4 5.4 0 0147.4 0z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E%0A") no-repeat 65% center ;
   background-position: 60% center;

}
    
  }
}


.header {
  width: 100%;
  min-height: 480px;
  overflow: hidden;
  @apply flex pb-12 pt-20 items-center relative justify-center;
  .project_logo {
  background-repeat: no-repeat;
background-size: auto 400px !important;
width: 600px;
height: 600px;
position: absolute;
bottom: -40%;
right: -90px;
opacity:0.02;

}
.project_icon{
  width: auto;
  height: 55px;
  @apply mr-4;
}
  .wrapper {
    width: 70%;
    @apply mt-10;
    h1 {
      @apply flex items-center text-5xl pb-4 mb-0 font-bold;
    }
    p {
      @apply text-xl mt-4;
      width: 80%;
      font-family: 'Open Sans';
      &:first-child {
       @apply mt-0;
      }
    }
    button {
    font-family: 'Open Sans';
      @apply pt-4 text-lg mt-6 px-6 pb-2 font-bold text-base;
      border-right: .5px solid rgba(255,255,255,0.3);
      border-top: .5px solid rgba(255,255,255,0.3);
      color: white !important;
      &:first-child {
       padding-left: 0 !important;
      }
      &:last-child {
       border-right: none;
      }
    }
  }
}

.page_main {
  width: 100%;
  display: block;
  padding: 0;
  margin: 0;
}

section {
  width: 100%;
  @apply pt-8 pb-10 flex justify-center;
  font-family: 'Open Sans';
  &:first-child {
  @apply pt-10;
}
  &:nth-child(odd) {
   background: #fafafa;
  }
  &.pages {
  .content {
  display: flex;
}
}
  .wrapper {
    @apply flex py-4 mx-auto inline-block;
    width: 70%;
    .info {
       flex: 0;
       min-width: 230px;
       @apply mr-20;
       h2 {
        font-family: Helvetica;
        @apply font-bold mb-4 pb-3;  
        font-size: 1.7rem;

      }
     }
    .page {
       width: 230px;
       height: 310px;
       @apply rounded-lg mr-6 relative border;
       overflow: hidden;
       background: #fff;
       background-position: 0% 0% !important;
       background-size: 100% !important;
       background-repeat: no-repeat !important;
       .page_info {
         position: absolute;
         top: 0%;
         height: 100%;
         background: rgba(0,0,0,0.89);
         transition: all .3s ease;
         color: white;
         transform: scale(0.8);
         opacity: 0;
         @apply flex rounded-lg flex-col text-center items-center justify-center;
         h3 {
         width: 85%;
          @apply font-bold text-lg leading-tight block mb-2 pb-2;
            border-bottom: .1px solid rgba(255,255,255,0.9);

        }
        button {
                  @apply rounded-full font-bold leading-tight block mt-4 py-2 px-3;
                  background: white; 
                  font-size: 13px;
                  color: black;
                  &:hover {
                  background: rgb(40, 56, 144);
                  color: white;
                }

      }
        .plus_icon {
        position: absolute;
        bottom: 30px;
        width: 20px;
        height: 20px;

      }
        p {
        @apply leading-tight;
        font-size: 13px;
        width: 85%;
        &.created {
        font-weight: 600;
        color: rgba(255,255,255,0.7);
        position: absolute;
        bottom: 10px;
      }
      }
       }
       &:hover {
         cursor: pointer;
         .page_info {
           opacity: 1;
           transform: scale(1);
         }
       }
     }
  
  }
}

.light-theme{color:#fff;box-shadow:0 0 20px 4px rgba(154,161,177,.15),0 4px 80px -8px rgba(36,40,47,.25),0 4px 4px -2px rgba(91,94,105,.15);background-color:#0088cc !important}.light-theme[x-placement^=top] .tippy-arrow{border-top:8px solid #0088cc;border-right:8px solid transparent;border-left:8px solid transparent}.light-theme[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #0088cc;border-right:8px solid transparent;border-left:8px solid transparent}.tippy-tooltip.light-theme[x-placement^=left] .tippy-arrow{border-left:8px solid #0088cc;border-top:8px solid transparent;border-bottom:8px solid transparent}.light-theme[x-placement^=right] .tippy-arrow{border-right:8px solid #0088cc;border-top:8px solid transparent;border-bottom:8px solid transparent}.light-theme .tippy-backdrop{background-color:#0088cc}.light-theme .tippy-roundarrow{fill:#0088cc}.light-theme[data-animatefill]{background-color:initial}

.tippy-tooltip  {
  /* Your styling here. Example: */
  background: #0088cc !important;
  color: white;
  border: 0 !important;
    border-radius: 100px !important;
  margin: 0;
z-index: 99999999;
position: relative;
}

.tooltip_custom {
  background: #0088cc !important;
  padding: 4px;
    border: 0 !important;

  border-radius: 100px !important;
  text-align: left;
  color: white !important;
  h2 {
    @apply font-bold text-base;
  }
  p {
    font-size: 13px;
  }
}


.project_menu {
  position: fixed;
  z-index: 9999;
  top: 0px;
  width: 100%;
  height: 60px;
  background: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  transition: all 0.4s ease;
  color: rgba(0, 0, 0, 0.8);
  border-bottom: .5px solid rgba(255,255,255,0.3);
  transition: background 0.35s ease;
  .menu_title {
    display: flex;
    @apply flex items-center;
    .logo {
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 500 500' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 250a250 250 0 11500 0 250 250 0 01-500 0zm97-103v106h42v-16h-26v-31h19v-16h-19v-27h26v-16zm80 91c6 0 8-4 8-11v-52c0-8-4-12-13-12h-4v75zm-25-91h23c19 0 27 10 27 29v48c0 20-8 29-26 29h-24zm63 25c0-17 9-27 25-27s24 9 24 27v10h-16v-11c0-8-3-11-8-11-6 0-9 3-9 11v59c0 7 3 11 9 11 5 0 8-4 8-11v-17h-10v-13h26v53h-8l-3-7c-4 7-9 10-16 10-14 0-22-11-22-30zm64-25h43v16h-26v27h18v16h-18v31h26v16h-43zM112 381H95V275h24c18 0 26 8 26 30 0 13-3 21-10 26l12 50h-17l-10-45h-8zm0-60v-31h6c8 0 10 3 10 15 0 11-2 16-10 16zm53-46l10 42h1l10-42h17l-19 62v44h-16v-42l-20-64zm69 90c6 0 9-4 9-11v-51c0-9-4-13-13-13h-4v75zm-24-90h23c18 0 27 9 27 29v47c0 20-8 30-26 30h-24zm136 46v-31h6c8 0 10 3 10 15 0 11-2 16-10 16zm-72-46h43v15h-26v28h19v15h-19v32h26v16h-43zm72 106h-16V275h24c17 0 25 8 25 30 0 13-3 21-10 26l12 50h-17l-10-45h-8zm57-30c1 11 4 16 11 16 6 0 10-4 10-10 0-9-6-14-15-23-12-12-20-21-20-35 0-15 11-26 25-26s24 10 25 26l-16 2c-1-9-3-13-9-13-5 0-9 4-9 10 0 9 7 16 17 25 11 11 18 19 18 34s-11 26-26 26-26-11-27-29zm-65-172v-42h-42a42 42 0 1142 42z' fill='rgba(255,255,255,0.9)' fill-rule='evenodd'/%3E%3C/svg%3E");
      background-size: cover;
      height: 38px;
      width: 38px;
      @apply mx-4 mr-3;
    }
    h2 {
      @apply text-xl font-bold;
      color: white;
      &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    }
  }
}

.news {
  .news_item {
    a.title {
  @apply border-b block mt-1 text-xl pb-2 mb-2;
  &:hover {
  @apply underline;
}
}
a.read {
  @apply rounded-full px-5 font-bold text-sm py-2 mt-3 inline-block;
  background: rgb(40, 56, 144);

  color: white;
}
  h4 {
  @apply text-xl font-bold;
  font-weight: 900;

  &.date {
color: rgb(40, 56, 144);
}
}
}
}

.contributors {
  @apply block;
  &:hover {
    .contributor_item {
     filter: grayscale(100%);

     &:hover {
       filter: grayscale(0%);
    
       z-index: 999;
       position: relative;
       box-shadow: 0 0 4px rgba(0,0,0,0.2);
                 transition: filter 0s ease, transform .3s ease;

     }
    }
  }
  .contributor_item {
   height: 70px;
   float: left;
          transition: filter .3s ease, transform .3s ease;

   @apply flex items-center border;
   width: 69.2px;
   flex-shrink: 0;
   background-size: cover !important;
   &:hover {
   cursor: pointer;
 }
  }
}

.info_date {
  @apply flex flex-col;
  font-weight: normal;
  span:first-child {
  @apply font-bold text-lg underline;
  &:hover {
  cursor: pointer
}
}
  span:nth-child(2) {
}
}
.navigation {
  @apply inline-flex mx-auto mt-3 w-auto items-center font-bold;
}


.events {
  width: 100%;
  @apply flex flex-col justify-center;
  .vuecal {
box-shadow: none;
.vuecal__cell-events {
  padding: 10px;
}
.vuecal__time-cell-label {
  display: none;
}
.vuecal__time-column {
  width: 0;
}
.vuecal__weekdays-headings {
  padding-left: 0;
}
.vuecal__cell--out-of-scope {
  display: none;
}
.vuecal__cell-events-count {
  background: rgb(0, 136, 204);
  padding: 0px;
  @apply px-2 font-bold;
  height: 14px !important;
}
.vuecal__event {
  padding: 10px;
  width: 90%;
  background: black;
  color: white;
  @apply border;
  background-color: rgb(0, 136, 204);
  border-radius: 4px;
  font-size: 13px;
  opacity: 1;
  transition: all .3s ease;
  &:hover {
  opacity: 1;
  cursor: pointer;
  transform: scale(1.01);
}
&.call {
  background-image: url("data:image/svg+xml,%3Csvg width='86' height='86' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M43 .5a42.5 42.5 0 100 85 42.5 42.5 0 000-85zm20.6 57.8c-1.1 2-2.6 3.7-4.4 5.1a11.9 11.9 0 01-5 2.6c-2.1.4-4.4.2-6.5-.6-3.6-1.2-7-3.2-9.7-6-2.2-2-5-5-5-5A40.6 40.6 0 0123.8 38a18.3 18.3 0 010-9.4c1-3.6 4.2-6.5 6.4-8.2a2.5 2.5 0 013.6.5l5.5 7.5c.5.7.6 1.6.3 2.4a12.4 12.4 0 01-4.7 6.1v.1c-.6.4-2.3 2 0 5 2.8 4 6 7.8 9.4 11.3.7.6 2.8 2.1 4.6-.3.7-1.2 3.3-6 5.1-5l9 7c1 .8 1.3 2.2.7 3.2z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/svg%3E%0A");
  background-size: 22px;
  background-position: center 10px;
  background-repeat: no-repeat;
  padding-top: 35px;
}
&.seminar {
  background-image: url("data:image/svg+xml,%3Csvg width='79' height='53' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFF' fill-rule='nonzero'%3E%3Ccircle cx='23.5' cy='19.4' r='13.3'/%3E%3Ccircle cx='55.3' cy='14.1' r='13.3'/%3E%3Cpath d='M78.4 43.3c-2.6-7.3-8.6-13-16.1-15.2-.2-.1-.5 0-.7.1-1.9 1-4 1.5-6.2 1.5s-4.4-.6-6.2-1.5l-.7-.1a24.6 24.6 0 00-10.7 6.5c4.8 3 8.5 7.6 10.5 12.9h27.2c2.1 0 3.6-2.2 2.9-4.2zM46.6 48.6l-.4-1.1c-.5-1.2-1-2.3-1.7-3.3l-.1-.2c-1-1.6-2.1-3-3.4-4.4l-.1-.1a23.4 23.4 0 00-10.4-6.2c-.2-.1-.5 0-.7.1-1.9 1-4 1.5-6.2 1.5s-4.4-.6-6.2-1.5l-.7-.1A24.4 24.4 0 00.6 48.5c-.7 2 .8 4.2 2.9 4.2h40.2c2.1.1 3.6-2 2.9-4.1z'/%3E%3C/g%3E%3C/svg%3E%0A");
    background-size: 28px ;
  background-position: center 12px;
  background-repeat: no-repeat;
  padding-top: 34px;
}
  .vuecal__event-title {
  font-weight: bold;
  text-transform: capitalize;
}
}
  }
  .vuecal__title-bar {
   background: none;
  }
  .today {
  .weekday-label {
  color: rgb(0, 136, 204);
  font-weight: 900;
}
}
}

@media only screen and (max-width: 1120px) {
.header {
  .wrapper {
  width: 90%;
}
}
section {
  .wrapper {
  width: 90%;
}
}
.footer {
  .wrapper {
  width: 90%;
}
}
}

@media only screen and (max-width: 768px) {
.header {
  .wrapper {
    p {
    width: 100%;
  }
}
}
section {
  .wrapper {
  width: 90%;
  display: flex; 
  @apply flex-col;
  .info {
  margin-right: 0;
  position: relative;
  p {
  display: none;
}
  .navigation{
  @apply absolute;
  top: 0;
  right: 0;
  margin-top: -.3rem;
}
}
}
}

.footer {
  .wrapper {
  flex-direction: column;
}
}
}
</style>
